module.exports = __webpack_public_path__ + "static/media/logo_cb.be9ec989.png";